import { render } from "./PricingArea.vue?vue&type=template&id=c4d8512c&scoped=true"
import script from "./PricingArea.vue?vue&type=script&lang=js"
export * from "./PricingArea.vue?vue&type=script&lang=js"

import "./PricingArea.vue?vue&type=style&index=0&id=c4d8512c&scoped=true&lang=css"
import "./PricingArea.vue?vue&type=style&index=1&id=c4d8512c&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Asistenca\\old-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4d8512c"]])

export default __exports__